<template>
  <div>
      <el-table
            :data="style_list[parentKey].option_list"
            style="width: 100%">
          <el-table-column 
            prop="option_name"
            label="Instructions">
                <template slot-scope="scope">
                    <span v-if="!scope.row.is_editable">
                        {{scope.row.option_name}}
                    </span>
                    <el-input v-else 
                        @focus="$event.target.select()"
                        size="small"
                        v-model="scope.row.edited_option">
                    </el-input>
                </template>
            </el-table-column>
            
            <el-table-column 
            prop="charges"
            label="Charges">
            <template slot-scope="scope">
                <div v-if="scope.row.charge_extra">
                    <div 
                        style="display: flex; flex-direction: row;"
                        v-if="scope.row.charge_type <2">
                        <el-input
                            v-if="scope.row.charge_type === 1"
                            placeholder="quantity"
                            @focus="$event.target.select()"
                            size="small"
                            type="number"
                            style="width: 80px;"
                            v-model="scope.row.qty">
                        </el-input> 
                        <span 
                            style="margin-left: 5px; margin-right: 5px; margin-top: 5px;" 
                            v-if="scope.row.charge_type === 1">
                            x
                        </span>
                        
                        <span v-if="scope.row.charge_type <2" style="margin-top: 5px;">
                            {{ formatCurrency(scope.row.charges) }}
                        </span>
                    </div>
                    <el-select v-model="scope.row.charges" filterable v-else-if="scope.row.charge_type === 2">
                        
                        <el-option 
                            v-for="index in parseInt(scope.row.charge_range[1])" 
                            :key="index"
                            :value="index"
                            :label="index" v-if="index>=parseInt(scope.row.charge_range[0])">
                            <span style="float: left">{{ index }}</span>
                        </el-option>

                    </el-select>
                    <el-input v-else 
                        @focus="$event.target.select()"
                        size="small"
                        type="number"
                        style="width: 150px;"
                        v-model="scope.row.charges">
                    </el-input>          
                </div>
            </template>
            </el-table-column>
            <el-table-column 
                v-if="style_list[parentKey].option_list.filter(t => t.picture_path !== null && t.picture_path.length > 0).length > 0"
                prop="picture_path"
                label="Sample Image" align="center">
                <template slot-scope="scope">
                    <img :src="scope.row.picture_path" width="100px">                    
                </template>
            </el-table-column> 
            
            <el-table-column
                fixed="right"
                label="">
                <template slot-scope="scope">
                    <div
                        v-if="(!scope.row.charge_extra 
                            || (scope.row.charge_extra 
                                    && ($store.getters.getSaleMasterDataProps.sale_status === 0 
                                    || checkIfModuleAccessAvailable('/salesorders', 'can_edit', false))))" 
                        style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        <el-button 
                            type="primary"
                            size="small"
                            @click="selectOption(scope.row)">
                            Ok
                        </el-button>
                    </div>                                        
                </template>
            </el-table-column>
            
        </el-table>
  </div>
</template>

<script>
export default {
    props: ['parentKey', 'style_list'],
    methods: {
        selectOption(data) {
            if(data.edited_option.length>0) {
               this.style_list[this.parentKey].edited_option = data.edited_option
            }
            this.style_list[this.parentKey].option_detail = data
            this.style_list[this.parentKey].style_choice_option_id = data.id
            this.style_list[this.parentKey].extra_charge = data.charges
            this.style_list[this.parentKey].qty = data.qty
            this.style_list[this.parentKey].extra_charge_notes = (data.qty>1 ? data.qty+' x ' : '')+data.option_name+' '+this.style_list[this.parentKey].style_name

            if(data.is_editable && data.edited_option.length === 0) {
                this.style_list[this.parentKey].edited_option = ""
                this.style_list[this.parentKey].option_detail = []
                this.style_list[this.parentKey].style_choice_option_id = 0
                this.style_list[this.parentKey].qty = 1
                this.style_list[this.parentKey].extra_charge = 0
                this.style_list[this.parentKey].extra_charge_notes = ""
            }
            
            this.$emit('close')
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/StyleListOption.vue